import { render, staticRenderFns } from "./reportTable.vue?vue&type=template&id=5b5f3aa8&scoped=true"
import script from "./reportTable.vue?vue&type=script&lang=js"
export * from "./reportTable.vue?vue&type=script&lang=js"
import style0 from "./reportTable.vue?vue&type=style&index=0&id=5b5f3aa8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5f3aa8",
  null
  
)

export default component.exports